'use client'

import { useEffect } from 'react'
import ErrorPage from '~/src/components/ErrorPage'
import { reportRumError } from '~/src/lib/reportRumError'

interface ErrorBoundaryPageProps {
  error: Error & { digest?: string }
  reset: () => void
}

/**
 * App Router segment error boundary. Renders the same `<ErrorPage />` the
 * Datadog `ErrorBoundary` fallback in AppProviders shows, and reports the
 * error manually — Next's built-in boundary catches it before it reaches the
 * Datadog one, so without `addError` the error would never hit RUM.
 */
export default function ErrorBoundaryPage({
  error,
}: ErrorBoundaryPageProps): React.ReactElement {
  useEffect(() => {
    console.error(error)
    reportRumError(error)
  }, [error])

  return <ErrorPage />
}
